import { useEffect, useState } from 'react';
import { readTheme } from '../utils/internalTheme';

/** Live internal theme skin (shared with /internal View panel). */
export default function useInternalTheme() {
  const [theme, setTheme] = useState(readTheme);

  useEffect(() => {
    const onTheme = (e) => {
      if (typeof e.detail === 'string') setTheme(e.detail);
      else setTheme(readTheme());
    };
    window.addEventListener('construx-internal-theme', onTheme);
    window.addEventListener('storage', onTheme);
    return () => {
      window.removeEventListener('construx-internal-theme', onTheme);
      window.removeEventListener('storage', onTheme);
    };
  }, []);

  return theme;
}
